define([
	"dojo/_base/declare",
	"csi/_base/modules",
	"csi/table/New"
], function(declare,modules,New) {

	return declare(New, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for request level
			var	ms = modules.hasModule("MaterialSpec");
			var	ps = modules.hasModule("ProductSpec");
			
			if (ms != ps) {
				view.addFixedValue("TemplateType", ms ? "DataPackageContainerType:Material" : "DataPackageContainerType:Style");
			}
						
			this.inherited(arguments);
		}
	});
});